import React from 'react';
import { Container } from 'react-bootstrap';
import LoadingView from './loadingView';
import './paymentCheckout.css';
import UTILS from '../common/utils';
import PoweredByBox from '../common/poweredByBox';
import ApiClient from '../ApiClient';
import DefaultCheckoutFormSchema from './../json-schema/default-merchant-schema.json';

const { getLiveLinkDetails, initLiveLinkPayment, getMerchantLogo } = ApiClient();

class LiveLinkCheckout extends React.Component {
    constructor(props) {
        super(props);
        let showNotFound = false;
        let params = new URLSearchParams(window.location.search);
        if (params.has('order')) {
            this.orderRef = params.get('order');
        } else {
            showNotFound = true;
        }

        this.primaryColor = UTILS.getPrimaryColor();
        this.state = {
            loading: true,
            order: null,
            show_not_found: showNotFound,
            checkout_form_schema: null,
            merchant_logo: null,
        };
    }

    async componentDidMount() {
        if (!this.state.show_not_found) {
            await this.getOrderDetails();
            await this.getMerchantLogo();
        }
    }

    getMerchantLogo = async () => {
        await getMerchantLogo(this.getMerchentId(), this.onGetMerchantLogoSuccess, this.onGetMerchantLogoFail);
    }

    onGetMerchantLogoSuccess = (responseDto) => {
        this.setState({
            merchant_logo: responseDto.response["merchant_logo"],
        });
    }

    onGetMerchantLogoFail = () => {
        console.log("fail");
    }

    getProfileName = () => {
        let paths = window.location.pathname.split("/");
        let profileName = paths.pop();
        while (profileName === '') {
            profileName = paths.pop();
        }

        return profileName;
    }

    getMerchentId = () => {
        const paths = (window.location.pathname || "")
            .split("/")
            .filter(Boolean);

        if (paths.length < 2) {
            console.error("Invalid URL structure:", paths);
            return null;
        }

        // The merchant ID is after the underscore: duroud_20169 → 20169
        const parts = paths[1].split("_");

        if (parts.length < 2) {
            console.error("Invalid merchant segment:", paths[1]);
            return null;
        }

        return parts[1]; // merchantId
    }

    getOrderDetails = async () => {
        this.setState({ loading: true });
        const profileName = this.getProfileName();
        await getLiveLinkDetails(profileName, this.orderRef, this.onGetOrderDetailsSuccess, this.onError)
    }

    onGetOrderDetailsSuccess = (responseDto) => {
        if (this.ObjectContains(responseDto, "succeeded") && responseDto["succeeded"]) {
            const order = responseDto['response'];
            this.setState({ order });

            const checkoutSchema = responseDto.response?.merchant_checkout_form_schema || DefaultCheckoutFormSchema;
            this.setState({ checkout_form_schema: checkoutSchema });
            this.setState({ loading: false });
        }
        else if (this.ObjectContains(responseDto, "succeeded") && !responseDto["succeeded"]) {
            alert(responseDto["error_message"]);
            this.setState({ loading: false });
        }
        else {
            alert("Something went wrong, try again later");
            this.setState({ loading: false });
        }
    }

    getPaymentCheckout = async (checkout_form_data = {}) => {
        this.setState({ loading: true });
        const profileName = this.getProfileName();
        await initLiveLinkPayment(profileName, {checkout_form_data, 'use_card_details_v2': true}, this.orderRef, this.onGetPaymentCheckout, this.onError)
    }

    onGetPaymentCheckout = (responseDto) => {
        if (this.ObjectContains(responseDto, "succeeded") && responseDto["succeeded"]) {
            window.open(responseDto.response.checkout_url, '_self');
        }
        else if (this.ObjectContains(responseDto, "succeeded") && !responseDto["succeeded"]) {
            alert(responseDto["error_message"]);
        }
        else {
            alert("Something went wrong, try again later");
        }

        this.setState({ loading: false })
    }

    ObjectContains = (dtoObject, internalObject) => {
        return dtoObject !== null && internalObject in dtoObject;
    }

    onError = (error) => {
        this.setState({ loading: false });
        console.log(error);
        alert(error.message);
    }

    showNotFound() {
        return (
            <div className='main-box p-4'>
                <h3 className='text-center text-danger mt-4'>Not found!</h3>
                <br />
                <PoweredByBox />
                <br />
            </div>
        )
    }

    showLoading() {
        return (
            <LoadingView color={this.primaryColor} />
        );
    }

    getMainClassName() {
        if (this.state.loading !== true) {
            return "col-lg-12 p-4 main-box";
        }

        return "col-lg-12 p-4";
    }

    productCard = (product) => {
        return (
            <div key={product.id}>
                <div className="row mt-1">
                    <h3 className='col-12'>{product.name}</h3>
                </div>
                <div className='row mt-2'>
                    <p className='col-12'>{product.description}</p>
                </div>
                <div className='row'>
                    <p>Price: <span className='price-color'>{product.price.toFixed(2)} EGP</span></p>
                </div>
            </div>
        )
    }

    merchantInfo = () => {
        return (
            <div className="product-card col-lg-3 p-3">
                {(this.state.merchant_logo !== null) && 
                    <div className='row'>
                        <div className='col-12 text-center' style={{ height: 300 }}>
                            <img
                                style={{ height: 'auto', width: 'auto', maxWidth: 200, maxHeight: 300 }}
                                src={this.state.merchant_logo}
                                alt={"Product"} />
                        </div>
                    </div>
                }
                {(this.state.merchant_logo !== null) && <hr />}
                <div className='row mt-4'>
                    {this.state.order.products.map(this.productCard)}
                </div>
            </div>
        )
    }

    getOrderTotalAmount = () => {
        let sum = 0;
        this.state.order.products.forEach(product => {
            sum += product.price;
        });
        return sum;
    }

    getCheckoutBtnText() {
        return 'Proceed to pay' + (this.state.order !== null ? ` ${this.getOrderTotalAmount().toFixed(2)} EGP` : '');
    }

    createDefaultCheckoutFormData = () => {
        return Object.fromEntries(
            Object.keys(this.state.checkout_form_schema?.schema?.properties || {}).map((key) => [key, ""])
        );
    }

    handleProceedToPay = () => {
        this.getPaymentCheckout(this.createDefaultCheckoutFormData());
    }

    showOrderDetails = () => {
        if (this.state.order === null) return null;

        return (
            <Container>
                <div className='row mt-2 text-center'>
                    <h2>Invoice</h2>
                </div>
                <br />
                <br />
                <div className='row mt-4'>
                    {this.merchantInfo()}
                </div>
                <br />
                <br />

                <div className='text-center'>
                    <button
                        className="btn btn-md primary-btn pl-4 pr-4"
                        style={{ width: "50%" }}
                        onClick={this.handleProceedToPay}
                    >
                        {this.getCheckoutBtnText()}
                    </button>
                </div>

                <br />
                <br />
                <PoweredByBox />
                <br />
                <br />
            </Container>
        );
    }

    render() {
        return (
            <Container style={{ marginTop: "50px" }}>
                <div className="row">
                    <div className={this.getMainClassName()}>
                        {
                            this.state.show_not_found ? this.showNotFound() :
                                this.state.loading ? this.showLoading() :
                                    this.showOrderDetails()
                        }
                    </div>
                </div>
            </Container>
        );
    }
}

export default LiveLinkCheckout;
